import { NgModule } from "@angular/core";
import { BankListComponent } from "@modules/+new/payments/features/fiat-deposit/modules/bank-selector/components/bank-list/bank-list.component";
import { SelectBankCommonComponent } from "@modules/+new/payments/features/fiat-deposit/modules/bank-selector/components/select-bank-common/select-bank-common.component";
import { SelectBankChildComponent } from "@modules/+new/payments/features/fiat-deposit/modules/bank-selector/components/select-bank-child/select-bank-child.component";
import { SelectBankComponent } from "@modules/+new/payments/features/fiat-deposit/modules/bank-selector/components/select-bank/select-bank.component";
import { CommonModule } from "@angular/common";
import { CoreModule } from "@modules/core/core.module";
import { ModalModule } from "@modules/app-modal/modal.module";
import { SharedPaymentsModule } from "@modules/+new/payments/shared-payments/shared-payments.module";
import { UniversalModalModule } from "@modules/+new/shared/universal-modal/universal-modal.module";
import { A11yModule } from "@angular/cdk/a11y";

@NgModule({
	imports: [CommonModule, CoreModule, ModalModule, SharedPaymentsModule, UniversalModalModule, A11yModule],
	declarations: [SelectBankComponent, SelectBankChildComponent, SelectBankCommonComponent, BankListComponent],
	exports: [SelectBankComponent, SelectBankChildComponent]
})
export class BankSelectorModule {}
